/**
 * FILTER DRAWER (V12, 2026-09-16). Amazon's phone pattern, which Aaron walked
 * through and liked (Dropbox/Shopify/FILTERS_REVIEW_16_SEP_2026.md, Part 2):
 *
 *   +------------------------------------+
 *   | Filters              35 results  X |
 *   |----------+-------------------------|
 *   | Suggested|  [Next day] [Champion]  |
 *   | Price    |  [Navy] [Black] ...     |
 *   | Colour  2|                         |
 *   | Who for  |     chips, never a      |
 *   | Size     |     list; the word is   |
 *   | Brand    |     always on the chip  |
 *   | ...      |                         |
 *   | Sort by  |                         |
 *   |----------+-------------------------|
 *   |  Clear all      [ Show 35 results ]|
 *   +------------------------------------+
 *
 * Built ON TOP of the theme's own filter form (#CollectionFilterForm inside
 * <filter-container>): every chip is a mirror of a checkbox in that form and
 * tapping it clicks the checkbox, so the theme's ajax reload, the URL, the
 * counts and Search & Discovery stay exactly as they are - only what the
 * shopper sees is ours. When the theme swaps the form in (after each filter),
 * the drawer rebuilds its panes from the new one.
 *
 * Phones only (up to 767px); the desktop sidebar is untouched.
 */
(function () {
  'use strict';
  var MOBILE = '(max-width: 767px)';
  var COLOUR_DOT = {
    'black': '#111', 'navy': '#1f2a44', 'brown': '#6b4226', 'grey': '#8a8a8a', 'blue': '#2f6fd6', 'green': '#2e7d32',
    'red/burgundy': '#a3122a', 'pink': '#e75480', 'purple': '#6a3fa0', 'orange/yellow': '#f5a623', 'white/cream': '#f4f1e8',
    'multi': 'linear-gradient(135deg,#e53935 0 25%,#fdd835 0 50%,#43a047 0 75%,#1e88e5 0)'
  };

  function text(el) { return (el ? el.textContent : '').replace(/\s+/g, ' ').trim(); }
  function count(section) {
    var n = section.querySelectorAll('.product-grid > .product-block').length;
    var more = !!section.querySelector('.pagination__next');
    return n + (more ? '+' : '');
  }

  function readGroups(form) {
    var groups = [];
    form.querySelectorAll('.filter-group').forEach(function (g) {
      if (g.hidden || g.classList.contains('filter-group--applied') || g.classList.contains('filter-group--availability')) return;
      var label = text(g.querySelector('.filter-group__heading__text'));
      var price = g.querySelector('.cc-price-range');
      var items = [];
      g.querySelectorAll('.filter-group__item').forEach(function (it) {
        if (it.hidden) return;
        var input = it.querySelector('input');
        if (!input) return;
        var c = parseInt(text(it.querySelector('.filter-group__item__count')), 10);
        items.push({ label: text(it.querySelector('.filter-group__item__text')) || text(it), input: input, count: isNaN(c) ? null : c,
          active: input.checked, disabled: input.disabled, sort: input.name === 'sort_by' });
      });
      if (!price && !items.length) return;
      if (/^dispatch$/i.test(label)) {                          // soonest first, not alphabetical
        var rank = { 'next day': 0, '2-3 days': 1, 'about a week': 2, '1-2 weeks': 3, 'about 2 weeks': 4 };
        var rk = function (i) { var r = rank[i.label.toLowerCase()]; return r === undefined ? 9 : r; };
        items.sort(function (a, b) { return rk(a) - rk(b); });
      }
      groups.push({ label: label, el: g, items: items, price: price, sort: items.length > 0 && items[0].sort,
        active: items.filter(function (i) { return i.active && !i.sort; }).length });
    });
    return groups;
  }

  function suggested(groups) {
    var pick = [];
    var byLabel = {};
    groups.forEach(function (g) { byLabel[g.label.toLowerCase()] = g; });
    var add = function (g, filter, max) {
      if (!g) return;
      var items = g.items.filter(function (i) { return !i.disabled && (!filter || filter(i)); });
      if (max) {
        items = items.slice().sort(function (a, b) { return (b.count || 0) - (a.count || 0); }).slice(0, max);
      }
      items.forEach(function (i) { if (pick.indexOf(i) === -1) pick.push(i); });
    };
    add(byLabel['dispatch'], function (i) { return /next day/i.test(i.label); });
    add(byLabel['condition'], function (i) { return /clearance/i.test(i.label); });
    add(byLabel["who it's for"] || byLabel['who its for'], null, 6);
    add(byLabel['brand'], null, 2);
    add(byLabel['colour'] || byLabel['color'], null, 3);
    add(byLabel['fill weight'], null, 2);
    return pick;
  }

  function chip(item, onTap) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'jhr-drawer__chip' + (item.active ? ' is-active' : '') + (item.disabled ? ' is-disabled' : '');
    b.setAttribute('aria-pressed', item.active ? 'true' : 'false');
    if (item.disabled) b.disabled = true;
    var dot = COLOUR_DOT[item.label.toLowerCase()];
    if (dot) {
      var d = document.createElement('span');
      d.className = 'jhr-drawer__dot';
      d.style.background = dot;
      b.appendChild(d);
    }
    var t = document.createElement('span');
    t.textContent = item.label;
    b.appendChild(t);
    if (item.active) {
      var tick = document.createElement('span');
      tick.className = 'jhr-drawer__tick';
      tick.textContent = '✓';
      b.appendChild(tick);
    }
    b.addEventListener('click', function () { onTap(item, b); });
    return b;
  }

  function Drawer(container) {
    this.container = container;
    this.section = container.closest('.shopify-section') || document.body;
    this.current = 'Suggested';
    this.brandQuery = '';
    this.pendingTimer = null;
    this.build();
  }
  Drawer.prototype.form = function () { return this.section.querySelector('#CollectionFilterForm'); };
  Drawer.prototype.build = function () {
    var self = this;
    var root = document.createElement('div');
    root.className = 'jhr-drawer';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-label', 'Filters');
    root.innerHTML =
      '<div class="jhr-drawer__head"><div class="jhr-drawer__title">Filters</div><div class="jhr-drawer__count"></div><button type="button" class="jhr-drawer__close" aria-label="Close">×</button></div>' +
      '<div class="jhr-drawer__body"><nav class="jhr-drawer__rail" aria-label="Filter groups"></nav><div class="jhr-drawer__pane"></div></div>' +
      '<div class="jhr-drawer__foot"><button type="button" class="jhr-drawer__clear">Clear all</button><button type="button" class="jhr-drawer__show"></button></div>';
    this.root = root;
    root.querySelector('.jhr-drawer__close').addEventListener('click', function () { self.close(); });
    root.querySelector('.jhr-drawer__show').addEventListener('click', function () { self.close(); });
    root.querySelector('.jhr-drawer__clear').addEventListener('click', function () {
      var link = self.section.querySelector('.filter-group__clear-link');
      if (link) { self.busy(true); link.click(); }
    });
    // the theme swaps the form in after every filter: rebuild from the new one
    var mo = new MutationObserver(function () {
      clearTimeout(self.pendingTimer);
      self.pendingTimer = setTimeout(function () { if (self.open) self.render(); }, 120);
    });
    mo.observe(this.section, { childList: true, subtree: true });
  };
  Drawer.prototype.busy = function (on) {
    this.root.classList.toggle('is-busy', !!on);
  };
  Drawer.prototype.show = function () {
    if (!this.root.isConnected) document.body.appendChild(this.root);
    this.open = true;
    document.documentElement.classList.add('jhr-drawer-open');
    this.render();
  };
  Drawer.prototype.close = function () {
    this.open = false;
    document.documentElement.classList.remove('jhr-drawer-open');
    if (this.root.isConnected) this.root.remove();
  };
  Drawer.prototype.render = function () {
    var self = this;
    var form = this.form();
    if (!form) return;
    this.busy(false);
    var groups = readGroups(form);
    var sug = suggested(groups);
    var rail = this.root.querySelector('.jhr-drawer__rail');
    var pane = this.root.querySelector('.jhr-drawer__pane');
    var n = count(this.section);
    this.root.querySelector('.jhr-drawer__count').textContent = n + ' results';
    this.root.querySelector('.jhr-drawer__show').textContent = 'Show ' + n + ' results';
    var anyActive = groups.some(function (g) { return g.active > 0; }) || !!this.section.querySelector('.filter-group--applied .filter-group__applied-item');
    this.root.querySelector('.jhr-drawer__clear').hidden = !anyActive;

    // the rail: Suggested, then the groups in Search & Discovery's order, Sort by last
    var entries = [];
    if (sug.length) entries.push({ label: 'Suggested', items: sug, suggested: true, active: sug.filter(function (i) { return i.active; }).length });
    groups.filter(function (g) { return !g.sort; }).forEach(function (g) { entries.push(g); });
    groups.filter(function (g) { return g.sort; }).forEach(function (g) { entries.push(g); });
    if (!entries.some(function (e) { return e.label === self.current; })) self.current = entries.length ? entries[0].label : '';
    rail.innerHTML = '';
    entries.forEach(function (e) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'jhr-drawer__rail-item' + (e.label === self.current ? ' is-current' : '');
      b.setAttribute('aria-current', e.label === self.current ? 'true' : 'false');
      b.innerHTML = '<span></span>' + (e.active ? '<b class="jhr-drawer__badge"></b>' : '');
      b.querySelector('span').textContent = e.label;
      if (e.active) b.querySelector('b').textContent = String(e.active);
      b.addEventListener('click', function () { self.current = e.label; self.render(); });
      rail.appendChild(b);
    });

    // the pane
    pane.innerHTML = '';
    var entry = entries.filter(function (e) { return e.label === self.current; })[0];
    if (!entry) return;
    var h = document.createElement('div');
    h.className = 'jhr-drawer__pane-title';
    h.textContent = entry.label;
    pane.appendChild(h);
    var onTap = function (item, btn) {
      if (item.disabled) return;
      btn.classList.toggle('is-active');
      self.busy(true);
      item.input.click();                                     // the theme takes it from here
    };
    if (entry.price) {
      pane.appendChild(this.pricePane(entry.price));
      return;
    }
    var items = entry.items;
    if (/^brand$/i.test(entry.label) && items.length > 8) {
      var search = document.createElement('input');
      search.type = 'search';
      search.className = 'jhr-drawer__search';
      search.placeholder = 'Find a brand';
      search.value = this.brandQuery;
      search.addEventListener('input', function () { self.brandQuery = search.value; self.renderChips(wrap, entry, onTap); });
      pane.appendChild(search);
      items = items.slice().sort(function (a, b) { return (b.count || 0) - (a.count || 0) || a.label.localeCompare(b.label); });
      entry = { label: entry.label, items: items, sort: entry.sort };
    }
    var wrap = document.createElement('div');
    wrap.className = 'jhr-drawer__chips';
    pane.appendChild(wrap);
    this.renderChips(wrap, entry, onTap);
  };
  Drawer.prototype.renderChips = function (wrap, entry, onTap) {
    var q = this.brandQuery.trim().toLowerCase();
    var items = /^brand$/i.test(entry.label) && q ? entry.items.filter(function (i) { return i.label.toLowerCase().indexOf(q) !== -1; }) : entry.items;
    wrap.innerHTML = '';
    if (!items.length) { wrap.innerHTML = '<p class="jhr-drawer__empty">Nothing here for this list.</p>'; return; }
    items.forEach(function (i) { wrap.appendChild(chip(i, onTap)); });
  };
  Drawer.prototype.pricePane = function (price) {
    var self = this;
    var min = price.querySelector('.cc-price-range__input--min');
    var max = price.querySelector('.cc-price-range__input--max');
    var box = document.createElement('div');
    box.className = 'jhr-drawer__price';
    var mk = function (src, label) {
      var l = document.createElement('label');
      l.className = 'jhr-drawer__price-field';
      var s = document.createElement('span'); s.textContent = label; l.appendChild(s);
      var i = document.createElement('input');
      i.type = 'number'; i.inputMode = 'numeric'; i.min = src.min || '0'; i.max = src.max || ''; i.placeholder = src.placeholder || (label === 'From' ? src.min : src.max) || '';
      i.value = src.value;
      i.addEventListener('change', function () {
        src.value = i.value;
        self.busy(true);
        src.dispatchEvent(new Event('change', { bubbles: true }));
      });
      l.appendChild(i);
      return l;
    };
    if (min) box.appendChild(mk(min, 'From'));
    if (max) box.appendChild(mk(max, 'To'));
    var note = document.createElement('p');
    note.className = 'jhr-drawer__hint';
    note.textContent = 'Prices in £. Leave a box empty for no limit.';
    box.appendChild(note);
    return box;
  };

  // one drawer per filter container; open it from the theme's own Filter button
  var drawers = new Map();
  document.addEventListener('click', function (evt) {
    if (!window.matchMedia(MOBILE).matches) return;
    var btn = evt.target.closest ? evt.target.closest('[data-toggle-filters]') : null;
    if (!btn) return;
    var container = (btn.closest('.shopify-section') || document).querySelector('filter-container');
    if (!container || !container.querySelector('#CollectionFilterForm')) return;
    evt.preventDefault();
    evt.stopPropagation();
    var d = drawers.get(container);
    if (!d) { d = new Drawer(container); drawers.set(container, d); }
    if (d.open) d.close(); else d.show();
  }, true);
})();
